// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"40dbee49","453":"8a33b806","732":"f7561d09","977":"38500387"}[chunkId] + ".chunk.js";
};